import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "observer",
  ref: "observerTarget"
}
const _hoisted_3 = {
  key: 1,
  class: "g-row g-row--align_center g-row--appearance_spaced"
}
const _hoisted_4 = {
  key: 0,
  class: "g-cell g-cols g-cols--narrow"
}
const _hoisted_5 = { class: "g-cell g-cols g-cols--12 g-cols--narrow-xl" }
const _hoisted_6 = {
  key: 0,
  class: "pagination"
}
const _hoisted_7 = { class: "pagination__item" }
const _hoisted_8 = ["href", "aria-label"]
const _hoisted_9 = {
  key: 0,
  class: "pagination__item"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 1,
  class: "pagination__item"
}
const _hoisted_12 = { class: "pagination__item" }
const _hoisted_13 = ["href", "onClick"]
const _hoisted_14 = { class: "pagination__item" }
const _hoisted_15 = ["textContent"]
const _hoisted_16 = { class: "pagination__item" }
const _hoisted_17 = ["href", "onClick"]
const _hoisted_18 = {
  key: 2,
  class: "pagination__item"
}
const _hoisted_19 = {
  key: 3,
  class: "pagination__item"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "pagination__item" }
const _hoisted_22 = ["href", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ControlButton = _resolveComponent("ControlButton")!
  const _component_AppIcon = _resolveComponent("AppIcon")!

  return ($props.total)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($props.scrollPaginate)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              ($setup.hasNext)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, null, 512))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              ($props.showMoreBtn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_ControlButton, {
                      type: "button",
                      onClick: $setup.loadMore,
                      disabled: !$setup.hasNext,
                      styling: "primary",
                      size: "md"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Show more')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "prepend"),
              _createElementVNode("div", _hoisted_5, [
                ($setup.range.max > 1)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                      _createElementVNode("li", _hoisted_7, [
                        _createElementVNode("a", {
                          class: _normalizeClass(["pagination__link pagination__link--prev", {'is-disabled': !$setup.hasPrevious}]),
                          href: $props.url && $setup.hasPrevious ? $setup.getUrl($setup.getPrevious()) : '#',
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (!$setup.hasPrevious ? '' : $setup.previous()), ["prevent"])),
                          "aria-label": _ctx.$t('Previous page')
                        }, [
                          _createVNode(_component_AppIcon, {
                            "aria-hidden": "true",
                            name: "i-chevron-left",
                            size: "lg"
                          })
                        ], 10, _hoisted_8)
                      ]),
                      ($setup.hasPrevious)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                            _createElementVNode("a", {
                              class: _normalizeClass(["pagination__link", { 'is-active': $props.startPage == $setup.range.min }]),
                              href:  $props.url ? $setup.getUrl($setup.range.min) : '#',
                              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.select($setup.range.min)), ["prevent"]))
                            }, _toDisplayString($setup.range.min), 11, _hoisted_10)
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.gaps.left)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["pagination__link pagination__link--dots is-dots", { 'is-active': $props.startPage }])
                            }, "...", 2)
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.fills.left, (page) => {
                        return (_openBlock(), _createElementBlock("li", _hoisted_12, [
                          _createElementVNode("a", {
                            class: _normalizeClass(["pagination__link", { 'is-active': $props.startPage }]),
                            href:  $props.url ? $setup.getUrl(page) : '#',
                            onClick: _withModifiers(($event: any) => ($setup.select(page)), ["prevent"])
                          }, _toDisplayString(page), 11, _hoisted_13)
                        ]))
                      }), 256)),
                      _createElementVNode("li", _hoisted_14, [
                        _createElementVNode("div", {
                          class: "pagination__link is-active",
                          textContent: _toDisplayString($setup.getPageNumber())
                        }, null, 8, _hoisted_15)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.fills.right, (page) => {
                        return (_openBlock(), _createElementBlock("li", _hoisted_16, [
                          _createElementVNode("a", {
                            class: "pagination__link",
                            href:  $props.url ? $setup.getUrl(page) : '#',
                            onClick: _withModifiers(($event: any) => ($setup.select(page)), ["prevent"])
                          }, _toDisplayString(page), 9, _hoisted_17)
                        ]))
                      }), 256)),
                      ($setup.gaps.right)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_18, _cache[4] || (_cache[4] = [
                            _createElementVNode("div", { class: "pagination__link is-dots" }, "...", -1)
                          ])))
                        : _createCommentVNode("", true),
                      ($setup.hasNext)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                            _createElementVNode("a", {
                              class: "pagination__link",
                              href:  $props.url ? $setup.getUrl($setup.range.max) : '#',
                              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.select($setup.range.max)), ["prevent"]))
                            }, _toDisplayString($setup.range.max), 9, _hoisted_20)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("li", _hoisted_21, [
                        _createElementVNode("a", {
                          class: _normalizeClass(["pagination__link pagination__link--next", {'is-disabled': !$setup.hasNext}]),
                          href: $props.url && $setup.hasNext ? $setup.getUrl($setup.getNext()) : '#',
                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (!$setup.hasNext ? '' : $setup.next()), ["prevent"])),
                          "aria-label": _ctx.$t('Next page')
                        }, [
                          _createVNode(_component_AppIcon, {
                            "aria-hidden": "true",
                            name: "i-chevron-right",
                            size: "lg"
                          })
                        ], 10, _hoisted_22)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _renderSlot(_ctx.$slots, "append")
            ]))
      ]))
    : _createCommentVNode("", true)
}